import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

  public onChangeLang$: Subscription = new Subscription();

  constructor(
    public helpersService: HelpersService,
    private _renderer2: Renderer2, 
    private router: Router, 
    private location: Location
  ) {
  }

  ngOnInit(): void {

    this.helpersService.nodeType = "pagina";
    if(this.helpersService.isBrowser) {
      const isRefreshed = this.helpersService.getLocalStorage("cookie-refresh");
      if (!isRefreshed) {
        this.helpersService.setLocalStorage("cookie-refresh", "1");
        window.location.reload();
      } else {
        this.helpersService.removeLocalStorage("cookie-refresh");
      }

      if (document.getElementById("Cookiebot") == null) {
        const script = document.createElement('script');
        script.setAttribute('id','Cookiebot');
        script.setAttribute('src','https://consent.cookiebot.com/uc.js');
        script.setAttribute('data-cbid','e30ba5f8-0142-487c-a2d9-ada2b61a7e37');
        script.setAttribute('type','text/javascript');
        script.setAttribute('async','');
        document.head.appendChild(script);
      }      
      if (document.getElementById("CookieDeclaration") == null) {
        let script = this._renderer2.createElement('script');
        script.type = `text/javascript`;
        script.id = "CookieDeclaration";
        script.src="https://consent.cookiebot.com/e30ba5f8-0142-487c-a2d9-ada2b61a7e37/cd.js";
        script.setAttribute("async", "");  
        this._renderer2.appendChild(document.getElementById("body-cookie"), script);
      }
      this.onChangeLang$ = this.helpersService.onChangeLang.subscribe(lang => {    
        const foundLang = this.helpersService.languages.findIndex((l: any) => l.codeApi == lang);
        if (foundLang >= 0) {
          this.location.replaceState(this.helpersService.languages[foundLang].routeCookiePolicy);
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.onChangeLang$ instanceof Subscription) {
      this.onChangeLang$.unsubscribe();
    }
    this.helpersService.removeLocalStorage("cookie-refresh");
  }

}
